var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresentationVideoTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 92,
    viewBox: "0 0 87 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8824_263)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_8824_263)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 92,
    rx: 31,
    fill: "white",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.9353 36.0082C60.5757 36.6111 60.9006 37.4265 60.8264 38.2449L58.7488 61.482C58.4733 64.5761 55.4681 67 51.9073 67H35.0285C31.4683 67 28.4631 64.5761 28.1865 61.482L26.1089 38.2449C26.0359 37.4265 26.3608 36.6111 26.9999 36.0082C27.6397 35.4053 28.5467 35.0595 29.489 35.0595H57.4469C58.3886 35.0595 59.2961 35.4053 59.9353 36.0082ZM59.5892 29.1531H52.7302L52.6195 28.1387C52.4241 26.3495 50.722 25 48.6608 25H38.3398C36.278 25 34.5765 26.3495 34.3811 28.1387L34.2704 29.1531H27.4108C26.0794 29.1531 25 30.0941 25 31.2548C25 32.4154 26.0794 33.3565 27.4108 33.3565H59.5892C60.9206 33.3565 62 32.4154 62 31.2548C62 30.0941 60.9206 29.1531 59.5892 29.1531Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_8824_263",
    x: -4,
    y: -4,
    width: 95,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8824_263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8824_263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8824_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 92,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationVideoTrash);
export default __webpack_public_path__ + "static/media/presentation-video-trash.2acf69498d807a88cbbbd1dbfd31c40b.svg";
export { ForwardRef as ReactComponent };